
	import { Vue, Component, Prop } from "vue-property-decorator";
	import { MessageType, IMessage } from "@common/Message";

	@Component({
		name: "message-view"
	})
	export default class MessageView extends Vue {
		@Prop({ default: <IMessage[]>[] })
		messages: IMessage[];

		protected getMessageClass(message: IMessage) {
			if (!message) return "";

			let cssClass = "alert";

			switch ((message.type || MessageType.Default)) {
				case MessageType.Trace:
					cssClass += " alert-secondary";
					break;
				case MessageType.Debug:
					cssClass += " alert-dark";
					break;
				case MessageType.Information:
					cssClass += " alert-info";
					break;
				case MessageType.Success:
					cssClass += " alert-success";
					break;
				case MessageType.Warning:
					cssClass += " alert-warning";
					break;
				case MessageType.Error:
				case MessageType.Fatal:
					cssClass += " alert-danger";
					break;
				default:
					cssClass += " alert-light";
					break;
			}

			if (typeof message.dismissable == 'undefined') message.dismissable = true;
			if (message.dismissable) cssClass += " alert-dismissible";
			cssClass += " fade show";
			return cssClass;
		}
	}
